import { compose, createStore, applyMiddleware } from 'redux';
import { Provider } from 'react-redux';
import React from 'react';
import ReduxThunk from 'redux-thunk';
import rootReducer from './root-reducer';
import { routerMiddleware } from 'connected-react-router';
import history from 'tradera-utils/history';
import { sentryReduxEnhancer } from 'tradera-utils/sentry/redux';
import { initializeState } from './state-initializer';
import initData from 'packages/init-data';

// Ensure only 1 redux store;
let reduxStore;

export { history };

// Apply middlewares via redux compose;
const getComposer = history => {
    const middlewares = [ReduxThunk];
    if (history) {
        middlewares.push(routerMiddleware(history));
    }
    let composeEnhancers;
    // If url contains ?debug-redux devtools will be enabled in production;
    if (
        (process && process.env && process.env.NODE_ENV !== 'production') ||
        window.location.search.includes('debug-redux')
    ) {
        composeEnhancers =
            window['__REDUX_DEVTOOLS_EXTENSION_COMPOSE__'] || compose;
    } else {
        composeEnhancers = compose;
    }
    return composeEnhancers(
        applyMiddleware(...middlewares),
        sentryReduxEnhancer
    );
};

// Hot reloading
const enableWebPackHotModuleReplacementForReducers = (module, store) => {
    if (!module.hot) {
        return;
    }
    module.hot.accept('./root-reducer', () => {
        const nextRootReducer = require('./root-reducer');
        store.replaceReducer(nextRootReducer);
    });
};

const configureStore = browserHistory => {
    reduxStore = createStore(
        rootReducer(browserHistory),
        getComposer(browserHistory)
    );

    // make it possible to observe state changes. used by syi
    reduxStore.observe = function(select, onChange) {
        var currentState;
        function handleChange() {
            var nextState = select(reduxStore.getState());
            if (nextState !== currentState) {
                var previousState = currentState;
                currentState = nextState;
                onChange(previousState, currentState);
            }
        }

        var unsubscribe = reduxStore.subscribe(handleChange);
        handleChange();
        return unsubscribe;
    };

    enableWebPackHotModuleReplacementForReducers(module, reduxStore);
    return reduxStore;
};

export const globalStore = () =>
    reduxStore ? reduxStore : configureStore(history);
const store = globalStore();

initializeState(initData)(store.dispatch);

window.getState = store.getState; // TODO: REmove me or put behind ENV-check (dev only)

export default store;

export const ProviderWithGlobalStore = props => (
    <Provider store={store} {...props} />
);
